$(function () {
    $('.detail-slider').owlCarousel({
        loop:false,
        margin: 5,
        items: 1,
        video: true,
        lazyLoad: true,
        thumbs: true,
        thumbsPrerendered: true,
        dots: false,
        responsiveClass: false,
        autoHeight: false,
        nav: true,
        navText:["<div class='nav-btn prev-slide'></div>","<div class='nav-btn next-slide'></div>"],
        URLhashListener:true,
        autoplayHoverPause:true,
        startPosition: 'URLHash'
    });

    $(document).on('click', '[data-toggle="lightbox"]', function (event) {
        event.preventDefault();
        $(this).ekkoLightbox({
            alwaysShowClose: true,
            leftArrow: '<span><img src="/webshop/imgs/prev.svg" style="background-color: #666666; opacity: .3" class="nav-arrow nav-arrow-left" alt="" width="50"></span>',
            rightArrow: '<span><img src="/webshop/imgs/next.svg" style="background-color: #666666; opacity: .7" class="nav-arrow nav-arrow-right" alt="" width="50"></span>'
        });
    });
});
